import PropTypes from 'prop-types';

export default PropTypes.shape({
  displayName: PropTypes.string.isRequired,
  homeLibraryFullName: PropTypes.string, // TODO: .isRequired,
  isActive: PropTypes.bool.isRequired,
  isStaff: PropTypes.bool.isRequired,
  userId: PropTypes.string.isRequired
});
